// extracted by mini-css-extract-plugin
export default {"imageDiv":"Images_imageDiv__XeVPX"};